import { RED } from '@features/gateOperationModal/constants';
import { teal } from '@mui/material/colors';
import { FC, PropsWithChildren } from 'react';

export const Accent: FC<PropsWithChildren> = ({ children }) => {
  return <b style={{ color: teal[400] }}>{children}</b>;
};

export const ErrorAccent: FC<PropsWithChildren> = ({ children }) => {
  return <b style={{ color: RED }}>{children}</b>;
};
